// What a report is about, and whether it has been dealt with.
export enum EContentReportTarget {
    PRODUCT = 'product',
    INGREDIENT = 'ingredient',
}

// The parts a report can be about: a product's tabs, then an ingredient's
// sections.
export enum EContentReportSection {
    OVERVIEW = 'overview',
    CONTENTS = 'contents',
    USAGES = 'usages',
    INGREDIENTS = 'ingredients',
    WARNINGS = 'warnings',
}

export enum EContentReportStatus {
    OPEN = 'open',
    RESOLVED = 'resolved',
}
